import { render, staticRenderFns } from "./ListProjectsPage.vue?vue&type=template&id=b30ea8da&scoped=true"
import script from "./ListProjectsPage.vue?vue&type=script&lang=js"
export * from "./ListProjectsPage.vue?vue&type=script&lang=js"
import style0 from "./ListProjectsPage.vue?vue&type=style&index=0&id=b30ea8da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30ea8da",
  null
  
)

export default component.exports